import React from 'react';
import { cn } from '../../lib/utils';
import { useBranding } from '../../contexts/BrandingContext';
import { getInputClasses } from '../../utils/brandingUtils';

const Textarea = React.forwardRef(({ className, hasError = false, ...props }, ref) => {
  const { branding } = useBranding();
  const inputClasses = getInputClasses(branding, hasError);
  
  return (
    <textarea
      className={cn(
        "min-h-[80px] resize-vertical",
        inputClasses,
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
